module.exports = __webpack_public_path__ + "img/icon_lotto.d5f8fda4.svg";